module.exports = __webpack_public_path__ + "public/images/captcha-star-selected.4fa2046ae1c0169b1b8997a783b6df2a.svg";